import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { IPurchaseDetail } from './purchase-detail.interface';
import { PurchaseDetailsService } from './purchases-detail.service';

@Component({
  selector: 'pg-purchases-details',
  templateUrl: './purchases-details.component.html'
})
export class PurchasesDetailsComponent {
  visible = true;
  @Input() idDocument: number;
  @Output() onHideData = new EventEmitter<boolean>();
  tableDetailSettings: ISettingsTable;
  detailPurchase: IPurchaseDetail[];

  constructor(private purchaseDetailService: PurchaseDetailsService) {}

  async ngOnInit() {
    this.tableDetailSettings = {
      title: 'Detalle de documento',
      columns: [
        { header: 'Descripción', field: 'productOfProviderDescription' },
        { header: 'Proveedor', field: 'providerName' },
        { header: 'Código de Proveedor', field: 'productOfProviderCode' },
        { header: 'Lote', field: 'lot' },
        { header: 'Cantidad.', field: 'quantity' },
        { header: 'Vencimiento', field: 'expAt' },
        { header: 'Precio de Compra', field: 'purchasePrice', pipe: 'Currency' }
      ]
    };

    const { data: detailPurchase, status } =
      await this.purchaseDetailService.getById(this.idDocument);

    if (status === 200) {
      this.detailPurchase = detailPurchase as IPurchaseDetail[];
      this.visible = true;
    }
  }
  onHideDataDialog() {
    this.visible = false;
    this.onHideData.emit();
  }
}
